import { defineAction } from '~/prix'
import { z } from 'zod'
import benefitProgramListAction from './benefitProgramList.action.json' with { type: 'json' }
import { benefitProgramObject } from '../benefitProgramObject'
import { enumerated } from '~/prix/types/enumerated'
import expression from '~/prix/types/expression'

export const benefitProgramExpression = expression(benefitProgramObject.shape)

const benefitProgramListDefinition = defineAction({
  ...benefitProgramListAction,

  input: z.object({
    filter: benefitProgramExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      id: 'Identificador',
      name: 'Nome',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(benefitProgramObject),
    count: z.number(),
  }),
})

export default benefitProgramListDefinition
